<template>
  <span
    :class="[classes, location]"
    class="mi"
  />
</template>

<script>
export default {
  name: 'VIcon',
  props: {
    icon: {
      type: String,
      required: false,
      default: 'plus',
    },
    size: {
      type: String,
      required: false,
      default: '',
    },
    space: {
      type: String,
      required: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: '',
    },
    right: Boolean,
    left: Boolean,
  },
  computed: {
    classes() {
      let classes = '';

      classes += this.icon ? `mi-${this.icon}` : '';
      classes += this.size ? ` text-${this.size}` : '';
      classes += this.color ? ` text-${this.color}` : '';
      classes += this.space ? ` ${this.space}` : '';

      return classes;
    },
    location() {
      if (this.right) {
        return 'ps-8';
      }

      if (this.left) {
        return 'pe-8';
      }

      return '';
    },
  },
};
</script>
